import { Box, Flex, StyleProps } from '@chakra-ui/react';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronLeftOutline, ChevronRightOutline } from '@bonusly/ds-icon';
import { Text } from '@bonusly/ds-typography';

import { useDatePickerContext } from '../context';

type CalendarControlsProps = StyleProps;

// Includes controls to navigate through months and displays the current month.
export const CalendarControls: FC<CalendarControlsProps> = (props) => {
	const { t } = useTranslation('components');
	const { onPrevMonth, onNextMonth, month } = useDatePickerContext();

	useEffect(() => {
		const listener = (e: KeyboardEvent) => {
			switch (e.key) {
				case 'PageDown':
					return onPrevMonth();
				case 'PageUp':
					return onNextMonth();
			}
		};

		document.addEventListener('keydown', listener);

		return () => {
			document.removeEventListener('keydown', listener);
		};
	}, [onPrevMonth, onNextMonth]);

	return (
		<Flex justifyContent="space-between" alignItems="center" mb={1} {...props}>
			<Box aria-label={t('date_picker.previous_month')} as="button" onClick={onPrevMonth} type="button">
				<ChevronLeftOutline />
			</Box>

			<Text variant="strong">
				{t('date_picker.calendar_header', {
					date: month,
				})}
			</Text>

			<Box aria-label={t('date_picker.next_month')} as="button" onClick={onNextMonth} type="button">
				<ChevronRightOutline />
			</Box>
		</Flex>
	);
};
